import { io } from "socket.io-client";
import { env } from "../config/env";
import { getAuthToken } from "../pages/AdminAuth/components/authStore";

let socket = null;

export function getSupportSocket() {
  if (socket) return socket;
  const base = env.SUPPORT_BASE_URL;
  if (!base) return null;
  socket = io(base, {
    auth: { token: getAuthToken() },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 800,
    reconnectionDelayMax: 5000,
  });
  return socket;
}

export function closeSupportSocket() {
  if (socket) socket.disconnect();
  socket = null;
}
